import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import React from 'react';

import Header from './Components/Header/Header';
import Footer from './Components/Footer/Footer';
import Body from './Components/Body/Body';

import background from './images/background.jpg';

function App(props) {
  return (
    <LoadNormalPage {...props} />
  );
}

function LoadNormalPage(props) {
  return (
    <>
      <img className="bgImage" src={background} alt="Illustration" />

      <div className="PageContainer">
        <Header {...props} />
        <Body {...props} />
        <Footer {...props} />
      </div>
    </>
  );
}

export default App;